import { Http, Url } from '@intelipost-js/secure-providers';
import { ScToast, ScDialog } from '@intelipost-js/secure-components';

export default {
  getBoxes({ commit }) {
    commit('setLoading', true);

    return Http.get('api/v1/box/available')
      .then((res) => {
        commit('setLoading', false);
        commit('setBoxes', res.data.content);
        return res;
      })
      .catch(() => commit('setLoading', false));
  },
  getBox({ commit, dispatch, state }, boxId) {
    commit('setLoading', true);

    return dispatch('getBoxes').then(() =>
      new Promise((resolve, reject) => {
        const selectedBox = state.boxes.find(box => box.id === Number(boxId));

        if (selectedBox) {
          commit('setBox', selectedBox);
          resolve();
        }

        reject();
      }),
    );
  },
  createBox({ commit, state }) {
    commit('setLoading', true);

    return Http.post('api/v1/box/save', state.box)
      .then(() => {
        commit('setLoading', false);
        ScToast.success('Caixa criada com sucesso');
      })
      .catch(() => commit('setLoading', false));
  },
  updateBox({ commit, state }) {
    commit('setLoading', true);

    return Http.post('api/v1/box/save', state.box)
      .then(() => {
        commit('setLoading', false);
        ScToast.success(`${state.box.description} atualizada com sucesso`);
      })
      .catch(() => commit('setLoading', false));
  },
  removeBox({ commit, dispatch }, box) {
    const { id, description } = box;

    ScDialog.confirm({
      title: 'Remover caixa',
      message: `Tem certeza que deseja remover a caixa <strong>${description}</strong>?`,
      confirmText: 'Remover',
      type: 'is-danger',
      hasIcon: true,
      icon: 'times-circle',
      onConfirm: () => {
        commit('setLoading', true);
        return Http.delete(`api/v1/box/${id}/delete`)
          .then(() => dispatch('getBoxes'))
          .then((res) => {
            commit('setLoading', false);
            ScToast.success(`${description} removida com sucesso.`);
            return Promise.resolve(res);
          })
          .catch((err) => {
            commit('setLoading', false);
            return Promise.reject(err);
          });
      },
    });
  },
  enableBox({ commit, state }, box) {
    const { id, enabled } = box;
    const pathParams = [
      id,
      'enable',
      enabled,
    ];

    commit('setLoading', true);
    return Http.post(Url.toQueryString('api/v1/box', null, pathParams))
      .then(() => commit('setLoading', false));
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/boxes/store/actions.js